<template>
  <p class="text-paragraph mb-4 text-sm text-neutral-40"><slot /></p>
</template>

<script>
export default {};
</script>

<style>
p.text-paragraph a {
  @apply font-normal text-primary-60 underline;
}
p.text-paragraph a:hover {
  @apply text-primary-40;
}
</style>
